import React, { useMemo } from 'react'
import Seo from '../Seo'

const env = (typeof process !== 'undefined' && process.env) || {}

const DEFAULTS = {
  embedUrl: 'https://app.leanit101.com/benjamin',
  embedToken:
    'eyJvcmdhbml6YXRpb25JZCI6NDQsImFnZW50U2x1ZyI6InJlY29tZWNhci1pbWVyc2FvLXNhbGVzLWFzc2lzdGFudCIsInRlbmFudFNsdWciOiJpZ3JlamEtcmVjb21lLWFyIiwiYXNzaXN0YW50TmFtZSI6IlJ1dGUiLCJncmVldGluZ3MiOnsiZW4iOiJHcmFjZSBhbmQgcGVhY2UuIEknbSBSdXRlIGZyb20gSW1lcnPDo28gUmVjb21lw6dhciDigJQgdGVsbCBtZSwgd2hhdCBicm91Z2h0IHlvdSBoZXJlIHRvZGF5PyIsImVzIjoiR3JhY2lhIHkgcGF6LiBTb3kgUnV0ZSwgZGUgbGEgSW5tZXJzacOzbiBSZWNvbWXDp2FyIOKAlCBjdcOpbnRhbWUsIMK_cXXDqSB0ZSB0cmFlIHBvciBhcXXDrSBob3k_IiwicHQiOiJHcmHDp2EgZSBwYXouIEV1IHNvdSBhIFJ1dGUsIGRhIEltZXJzw6NvIFJlY29tZcOnYXIg4oCUIG1lIGNvbnRhLCBvIHF1ZSB0ZSB0cm91eGUgYXTDqSBhcXVpIGhvamU_In0sIm1ldGFkYXRhIjp7ImNoYW5uZWxEZWZhdWx0Ijoid2ViX2VtYmVkIiwiZGVmYXVsdExvY2FsZSI6InB0LUJSIn19.43c4b23b50a76403cc07daad95bcbd4c1620344c4059632331cfb068a52e1e41',
  agentSlug: 'recomecar-imersao-sales-assistant',
  tenantSlug: 'igreja-recome-ar',
  organizationId: '44',
  assistantName: 'Rute',
  channel: 'web_embed',
  utmSource: 'leanit101.com',
  utmCampaign: 'imersao-recomecar-poc',
}

const ImersaoRecomecarPage = () => {
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') return new URLSearchParams('')
    return new URLSearchParams(window.location.search || '')
  }, [])

  const embedToken =
    queryParams.get('token') ||
    env.REACT_APP_IMERSAO_RECOMECAR_EMBED_TOKEN ||
    DEFAULTS.embedToken

  const agentSlug =
    queryParams.get('agentSlug') ||
    env.REACT_APP_IMERSAO_RECOMECAR_AGENT_SLUG ||
    DEFAULTS.agentSlug

  const tenantSlug = (
    queryParams.get('tenantSlug') ||
    env.REACT_APP_IMERSAO_RECOMECAR_TENANT_SLUG ||
    DEFAULTS.tenantSlug
  )
    .toString()
    .trim()
    .toLowerCase()

  const organizationId =
    queryParams.get('organizationId') ||
    env.REACT_APP_IMERSAO_RECOMECAR_ORGANIZATION_ID ||
    DEFAULTS.organizationId

  const assistantName =
    queryParams.get('assistantName') ||
    env.REACT_APP_IMERSAO_RECOMECAR_ASSISTANT_NAME ||
    DEFAULTS.assistantName

  const channel = queryParams.get('channel') || DEFAULTS.channel
  const utmSource = queryParams.get('utm_source') || DEFAULTS.utmSource
  const utmCampaign = queryParams.get('utm_campaign') || DEFAULTS.utmCampaign

  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams()
    if (embedToken) params.set('token', embedToken)
    params.set('agentSlug', agentSlug)
    params.set('tenantSlug', tenantSlug)
    params.set('organizationId', organizationId)
    params.set('assistantName', assistantName)
    params.set('channel', channel)
    params.set('locale', 'pt-BR')
    if (utmSource) params.set('utm_source', utmSource)
    if (utmCampaign) params.set('utm_campaign', utmCampaign)
    params.set('meta.source', 'imersao-recomecar-poc')
    params.set('meta.partner', 'igreja-recomecar')

    const baseUrl =
      env.REACT_APP_IMERSAO_RECOMECAR_EMBED_URL || DEFAULTS.embedUrl
    return `${baseUrl}?${params.toString()}`
  }, [
    agentSlug,
    assistantName,
    channel,
    embedToken,
    organizationId,
    tenantSlug,
    utmCampaign,
    utmSource,
  ])

  return (
    <section className="relative flex min-h-screen w-full flex-col overflow-hidden bg-[#0e0913] text-white">
      <Seo
        title="Imersão Recomeçar | Rute"
        description="POC privada para validar a Rute, agente comercial da Imersão Recomeçar."
        path="/imersao-recomecar"
        noindex
      />

      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#25142d] via-[#0e0913] to-[#0e0913]" />
        <div
          className="absolute left-[7%] top-[-180px] h-[660px] w-[660px] rounded-full opacity-28"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(213,184,107,0.26) 0%, rgba(213,184,107,0) 70%)',
            filter: 'blur(60px)',
          }}
        />
        <div
          className="absolute bottom-[-220px] right-[-120px] h-[580px] w-[580px] rounded-full opacity-20"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(180,126,255,0.18) 0%, rgba(180,126,255,0) 68%)',
            filter: 'blur(52px)',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.05]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)',
            backgroundSize: '30px 30px',
          }}
        />
      </div>

      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 py-12 md:py-16">
        <header className="space-y-4 text-center">
          <p className="text-xs uppercase tracking-[0.42em] text-[#e6cd8c]/76">
            Igreja Recomeçar
          </p>
          <h1 className="text-3xl font-semibold md:text-5xl">
            Rute • vendas acolhedoras para a Imersão Recomeçar
          </h1>
          <p className="mx-auto max-w-3xl text-base text-slate-200 md:text-lg">
            Página de POC para validar a Rute como ponto inicial de conversa
            para leads interessados na Imersão Recomeçar, com foco em
            esclarecimento, tratamento de objeções e avanço natural para a
            inscrição.
          </p>
        </header>

        <div className="grid gap-6 lg:grid-cols-[1.1fr_minmax(320px,0.9fr)]">
          <div className="w-full overflow-hidden rounded-[28px] border border-[#e6cd8c]/12 bg-[#17101f]/78 shadow-2xl">
            <div className="border-b border-white/8 px-5 py-4">
              <div className="text-[11px] uppercase tracking-[0.34em] text-[#e6cd8c]/74">
                Conversa ao vivo
              </div>
              <div className="mt-2 text-sm text-slate-300">
                Fluxo em português voltado para acolher o lead, explicar a
                proposta da imersão, responder dúvidas com maturidade cristã e
                conduzir para a inscrição quando houver intenção real.
              </div>
            </div>
            <div className="relative h-[560px] w-full md:h-[660px]">
              <iframe
                title="Imersão Recomeçar — Rute"
                src={iframeSrc}
                allow="clipboard-read; clipboard-write"
                className="absolute inset-0 h-full w-full"
                style={{ background: 'transparent', border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="grid content-start gap-4">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6cd8c]/78">
                Posicionamento
              </div>
              <h2 className="mt-3 text-xl font-semibold">
                Calor humano, clareza e condução para decisão
              </h2>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                A Rute foi configurada para soar acolhedora, segura e cristã,
                sem virar pregadora nem atendente genérica. O foco é ajudar a
                pessoa a entender a imersão, lidar com objeções e avançar para a
                inscrição no momento certo.
              </p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6cd8c]/78">
                O que observar
              </div>
              <ul className="mt-3 space-y-3 text-sm leading-6 text-slate-200">
                <li>Se a Rute acolhe bem sem soar artificial, manipulativa ou excessivamente religiosa.</li>
                <li>Se ela explica a Imersão Recomeçar com clareza prática, não como sermão longo.</li>
                <li>Se ela lida bem com objeções de preço, tempo e receio sem pressionar cedo demais.</li>
                <li>Se o link de pagamento aparece no timing certo, quando o lead realmente está pronto.</li>
              </ul>
            </div>

            <div className="rounded-2xl border border-[#e6cd8c]/18 bg-[#191120] p-5">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6cd8c]/84">
                Compartilhamento
              </div>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                Use este link com o cliente para validação da POC:
              </p>
              <code className="mt-3 block break-all text-xs text-[#f3dfae] md:text-sm">
                https://leanit101.com/imersao-recomecar
              </code>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6cd8c]/78">
                Contexto da POC
              </div>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                Esta página envia o embed com <strong>organizationId 44</strong>,
                locale <strong>pt-BR</strong> e metadados específicos da POC da
                Imersão Recomeçar, voltada para vendas consultivas curtas,
                acolhimento inicial e conversão para inscrição no evento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ImersaoRecomecarPage
